export default __webpack_public_path__ + "static/media/BIZ.b64fd7c6.svg";